import './index.css';
import { useEffect, useState } from 'react';

function getNextCrawlTime() {
  const now = new Date();

  const crawlTimesUTC = [
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 7, 0, 0)),
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 18, 0, 0))
  ];

  // Find the next crawl time
  for (const crawlTime of crawlTimesUTC) {
    if (now < crawlTime) {
      return crawlTime;
    }
  }

  // If both today’s times have passed, the next is tomorrow at 7:00 AM UTC
  const tomorrow7UTC = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1, 7, 0, 0));
  return tomorrow7UTC;
}

function formatTimeLeft(ms) {
  const totalSeconds = Math.floor(ms / 1000);
  const hrs = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  return `${hrs}h ${mins}m ${secs}s`;
}


function CrawlCountdown() {
  const [timeLeft, setTimeLeft] = useState(() => getNextCrawlTime() - new Date());

  useEffect(() => {
    const interval = setInterval(() => {
      const nextCrawl = getNextCrawlTime();
      setTimeLeft(nextCrawl - new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="crawl-countdown">Next crawl in: {formatTimeLeft(timeLeft)}
    </div>
  );
}

export default CrawlCountdown;
